import { Grid, Paper, Box, Typography } from '@mui/material';

const InfoItem = ({ icon, label, value, xs = 12, sm = 6 }) => (
  <Grid item xs={xs} sm={sm}>
    <Paper
      elevation={0}
      sx={{
        p: 3,
        borderRadius: '12px',
        backgroundColor: 'white',
        height: '100%',
        transition: 'all 0.2s ease-in-out',
        boxShadow: '0 1px 3px rgba(0,0,0,0.04)',
        border: '1px solid #f8f9fa',
        '&:hover': {
          backgroundColor: '#f8f9ff',
          transform: 'translateY(-2px)',
          boxShadow: '0 4px 12px rgba(146, 145, 239, 0.15)',
          borderColor: '#9291ef',
        },
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 1.5 }}>
        <Box
          sx={{
            p: 1.2,
            borderRadius: '10px',
            backgroundColor: '#9291ef',
            color: 'white',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            boxShadow: '0 2px 4px rgba(146, 145, 239, 0.3)',
          }}
        >
          {icon}
        </Box>
        <Typography
          variant='subtitle2'
          sx={{
            color: '#6c757d',
            fontWeight: 600,
            fontSize: '0.875rem',
            letterSpacing: '0.3px',
          }}
        >
          {label}
        </Typography>
      </Box>
      <Typography
        variant='body1'
        sx={{
          color: '#2c3e50',
          fontWeight: 600,
          lineHeight: 1.5,
          fontSize: '0.95rem',
        }}
      >
        {value}
      </Typography>
    </Paper>
  </Grid>
);

export default InfoItem;

